import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * UserRoles API
 */
class UserRolesApi extends ApiBase {
  /**
   * create user/role links
   * @param {*} userRoles List of user/roles
   */
  async create(userRoles) {
    const request = {
      url: `${this.API_URL}/roles/userroles`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(userRoles)
    };

    const response = await axios.request(request);

    return response.data;
  }

  async delete(userRoles) {
    const request = {
      url: `${this.API_URL}/roles/userroles`,
      headers: this.getHeaders(),
      method: 'DELETE',
      data: JSON.stringify(userRoles)
    };

    const response = await axios.request(request);

    return response.data;
  }
}

export default new UserRolesApi();
